import { useMemo, useState, useEffect } from 'react';
import { createContext } from "react";
import { useParams } from 'react-router-dom';

import { useAtleta } from '../../Hooks/Atleta/useAtleta'
import { usePrueba } from '../../Hooks/Prueba/usePrueba';

import { notification } from 'antd';
import { useNavigate } from 'react-router-dom';
import { pruebaConRep } from '../../Util/pruebaReps';

export const PruebaContext = createContext();

export const PruebaContextProvider = ({ children }) => {
    const { id } = useParams()
    const navigate = useNavigate()
    const {pruebas, getPrueba} = usePrueba()
    const {atletas, getAtleta} = useAtleta()
    const [cargando, setCargando] = useState(false)
    const [repIndex, setRepIndex] = useState(0)

    const pruebaActiva = useMemo(
        () => pruebaConRep(pruebas[0], repIndex),
        [pruebas, repIndex]
    );

    const cargar = async () => {
            try {
                setCargando(true)
                await getPrueba(id)
            } catch (err) {
                notification.error({ description: err?.response?.data?.mensaje || err.toString() })
                navigate('/pruebas')
            } finally {
                setCargando(false)
            }
        }
    
    const cargarAtleta = async () => {
            try {
                setCargando(true)
                await getAtleta(pruebas[0]?.atleta)
            } catch (error) {
                notification.error({ description: error.response.data.mensaje })
                navigate('/pruebas')
            } finally {
                setCargando(false)
            }
        }
    
    
        useEffect(() => {
            cargar()
        }, [id])

        useEffect(() => {
            setRepIndex(0)
        }, [id])
    
        useEffect(() => {
            if (pruebas[0]?.atleta) {
                cargarAtleta()
            }
        }, [pruebas])

    return <PruebaContext.Provider value={{ pruebas,
        pruebaActiva,
        repIndex,
        setRepIndex,
        atletas, 
        cargando, 
        setCargando, 
        id}}>
        {children}
    </PruebaContext.Provider>
}
